import { getExperimentValue } from 'app/common/helpers/experiments';

const experiments = {
  desktopHeader2019({ isLiteHeader, brand }) {
    let desktopHeader2019 = false;

    if (!isLiteHeader && brand.isGroupon) {
      desktopHeader2019 = getExperimentValue('LS-5958_NewDesktopHeader_USCA');
      if (desktopHeader2019) {
        document.getElementById('ls-header').classList.add('header-redesign');
      }
    }

    return desktopHeader2019;
  },
};

export function setToInitialState(flag, value) {
  value && Object.assign(window.__LS_INITIAL_STATE__.flags, { [flag]: value });
}

export default function checkInitialExp(config = {}) {
  Object.assign(config, window.__LS_INITIAL_STATE__.app);

  Object.entries(experiments).forEach(([key, fn]) =>
    setToInitialState(key, fn(config))
  );
}
